import { render, staticRenderFns } from "./mvc.vue?vue&type=template&id=74cccdb2&"
import script from "./mvc.vue?vue&type=script&lang=js&"
export * from "./mvc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TritonPresentation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cccdb2')) {
      api.createRecord('74cccdb2', component.options)
    } else {
      api.reload('74cccdb2', component.options)
    }
    module.hot.accept("./mvc.vue?vue&type=template&id=74cccdb2&", function () {
      api.rerender('74cccdb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Scripts/app/mvc.vue"
export default component.exports